import type { PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { Icon } from 'components/UI/Icon';
import Link from 'components/UI/Link/Link';
import type { MenuItemProps } from 'types/menu';
import type { PropsWithClassName } from 'types/react-props';
import { linkUrl } from 'utils/url';
import styles from './MenuLink.module.scss';

type MenuLinkProps = PropsWithClassName<
  PropsWithChildren<{
    menuItem: MenuItemProps;
    dataVarsAction?: string;
    disableClick?: boolean;
  }>
>;

const MenuLink = ({ menuItem, dataVarsAction, disableClick, children, className }: MenuLinkProps) => (
  <>
    {menuItem.type === 'content' && <></>}
    {menuItem.type === 'space' && <Link href="#">{menuItem.title}</Link>}
    {disableClick && menuItem.target !== '_blank' && <div>{menuItem.title}</div>}
    {(menuItem.type === 'link' || menuItem.type === 'section') && (!disableClick || menuItem.target === '_blank') ? (
      <Link
        className={clsx(styles.link, className)}
        href={!menuItem.url ? '#' : linkUrl(menuItem.url, menuItem.type === 'section')}
        target={menuItem.target}
        noFollow={menuItem?.noFollow}
        data-vars-category="navigation"
        data-vars-label={menuItem.title}
        data-vars-action={dataVarsAction}
      >
        {children ?? (
          <>
            {menuItem.fields?.sponsored || menuItem.fields?.subtitle ? (
              <span className={styles.sponsoredTitleWrapper}>
                {menuItem.title}
                <span className={styles.sponsoredLabel}>
                  {menuItem.fields?.sponsored ? 'Anzeige' : menuItem.fields?.subtitle}
                </span>
              </span>
            ) : (
              menuItem.title
            )}
            {menuItem.target === '_blank' && <Icon name="externalLink" className={styles.externalLinkIcon} />}
          </>
        )}
      </Link>
    ) : null}
  </>
);

export default MenuLink;
